export const USER_STATUS = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  SECESSION: 'secession',
};

const LABELS = {
  [USER_STATUS.ACTIVE]: '활성화',
  [USER_STATUS.INACTIVE]: '비활성화',
  [USER_STATUS.SECESSION]: '계정 잠금',
};

export const USER_STATUS_OPTIONS = [
  { value: USER_STATUS.ACTIVE, label: LABELS[USER_STATUS.ACTIVE] },
  { value: USER_STATUS.INACTIVE, label: LABELS[USER_STATUS.INACTIVE] },
  { value: USER_STATUS.SECESSION, label: LABELS[USER_STATUS.SECESSION] },
];

export const USER_STATUS_TONES = {
  [USER_STATUS.ACTIVE]: {
    bg: '#E8F8EF',
    color: '#1B7A4E',
    border: '#B7E4C7',
    hover: '#D8F3E4',
  },
  [USER_STATUS.INACTIVE]: {
    bg: '#F3F4F6',
    color: '#4B5563',
    border: '#E5E7EB',
    hover: '#EAECEF',
  },
  [USER_STATUS.SECESSION]: {
    bg: '#FDECEC',
    color: '#C0392B',
    border: '#F5C6C2',
    hover: '#F9D6D3',
  },
};

export const isActiveStatus = (status) => status === USER_STATUS.ACTIVE;

export const nextToggleStatus = (status) =>
  status === USER_STATUS.ACTIVE ? USER_STATUS.INACTIVE : USER_STATUS.ACTIVE;

export const userStatusLabel = (status) => LABELS[status] ?? LABELS[USER_STATUS.INACTIVE];

export const userStatusTone = (status) =>
  USER_STATUS_TONES[status] ?? USER_STATUS_TONES[USER_STATUS.INACTIVE];

export const SECESSION_REASON_MAX_LENGTH = 500;

export const userStatusChangeMessage = (fromStatus, toStatus) => {
  if (!toStatus) {
    if (fromStatus === USER_STATUS.ACTIVE) {
      return '정말로 해당 계정을 비활성화 상태로 변경하시겠습니까?';
    }
    if (fromStatus === USER_STATUS.SECESSION) {
      return '정말로 해당 계정을 활성화 상태로 복구하시겠습니까?';
    }
    return '정말로 해당 계정을 활성화 상태로 변경하시겠습니까?';
  }

  return `정말로 해당 계정을 ${userStatusLabel(fromStatus)}에서 ${userStatusLabel(toStatus)}(으)로 변경하시겠습니까?`;
};
